
export const ticket_and_support_permissions ={
    reqiredPermissions:["add_ticket","change_ticket","view_ticket","delete_ticket"],
    commentTicketPermisions:["add_ticketcomment","change_ticketcomment","view_ticketcomment","delete_ticketcomment"]
}
